import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const SerachBar = ({ onDebouncing }) => {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const timer = setInterval(() => {
      //   if (searchText != null ) {
      // console.log(searchText);

      onDebouncing(searchText);
      clearTimeout(timer);
      //   }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div className="adminSearchContainer">
      <input
        className="adminSearchInput"
        type="text"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value.trim())}
        placeholder="Search here"
      />
    </div>
  );
};

export default SerachBar;
